import Quill from 'quill';

/**
 * Por padrão o blot de imagem do Quill só preserva alt/height/width — o atributo
 * style é descartado ao serializar. Como o redimensionamento e a escolha entre
 * imagem "em linha" ou "abaixo" são gravados em style, sem isto o ajuste do
 * usuário se perderia ao salvar a ação (item 4b).
 *
 * Importar este arquivo uma vez registra o blot estendido globalmente.
 */
const BaseImage = Quill.import('formats/image');

const KEPT_ATTRIBUTES = ['alt', 'height', 'width', 'style', 'class'];

class ResizableImage extends BaseImage {
    static formats(domNode) {
        return KEPT_ATTRIBUTES.reduce((formats, attribute) => {
            if (domNode.hasAttribute(attribute)) {
                formats[attribute] = domNode.getAttribute(attribute);
            }
            return formats;
        }, {});
    }

    format(name, value) {
        if (KEPT_ATTRIBUTES.indexOf(name) > -1) {
            if (value) {
                this.domNode.setAttribute(name, value);
            } else {
                this.domNode.removeAttribute(name);
            }
            return;
        }
        super.format(name, value);
    }
}

ResizableImage.blotName = 'image';
ResizableImage.tagName = 'IMG';

Quill.register(ResizableImage, true);

export default ResizableImage;
